export default function containsOnlyAlphabetical(str: string): boolean {
  return /^[A-Za-z]+$/.test(str);
}
